module.exports = __webpack_public_path__ + "8b90648f348cfb4a09025ecb20219095.svg";